import React from "react";
import { Box, Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { lighten } from "@mui/material/styles";

interface ThemeOptions {
  bgVariant: "white" | "accent";
  size: "small" | "medium";
}

const iconSizes = {
  small: {
    background: 45,
    icon: 24,
  },
  medium: {
    background: 56,
    icon: 32,
  },
};

const useIconStyles = makeStyles<Theme, ThemeOptions>((theme) => ({
  root: ({ bgVariant, size }) => ({
    width: iconSizes[size].background,
    height: iconSizes[size].background,
    borderRadius: theme.spacing(1.5),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    backgroundColor:
      bgVariant === "white"
        ? theme.palette.common.white
        : lighten(theme.palette.accent.main, 0.9),

    color: theme.palette.accent.main,

    "& svg": {
      width: iconSizes[size].icon,
      height: iconSizes[size].icon,
    },

    "& svg path": {
      fill: `${theme.palette.accent.main} !important`,
      stroke: `${theme.palette.accent.main} !important`,
      strokeWidth: "0.5 !important",
    },
  }),
}));

interface ProfileIconBlockProps {
  icon: React.ReactNode;
  bgVariant?: "white" | "accent";
  size?: "small" | "medium";
}

export const ProfileIconBlock: React.FC<ProfileIconBlockProps> = ({
  icon,
  bgVariant = "white",
  size = "medium",
}) => {
  const s = useIconStyles({ bgVariant, size });

  return <Box className={s.root}>{icon}</Box>;
};
